declare namespace $ {

	type $mol_view__sub_shm_tree_1 = $mol_type_enforce<
		ReturnType< $shm_tree['guide_rows'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_check_expand__style_shm_tree_2 = $mol_type_enforce<
		({ 
			'left': ReturnType< $shm_tree['toggle_left'] >,
		})  & ReturnType< $mol_check_expand['style'] >
		,
		ReturnType< $mol_check_expand['style'] >
	>
	type $mol_check_expand__checked_shm_tree_3 = $mol_type_enforce<
		ReturnType< $shm_tree['expanded'] >
		,
		ReturnType< $mol_check_expand['checked'] >
	>
	type $mol_view__style_shm_tree_4 = $mol_type_enforce<
		({ 
			'marginLeft': ReturnType< $shm_tree['content_left'] >,
		})  & ReturnType< $mol_view['style'] >
		,
		ReturnType< $mol_view['style'] >
	>
	type $mol_view__sub_shm_tree_5 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_tree_6 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_tree_7 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $shm_tree extends $mol_list {
		id( id: any): string
		visible_rows( ): readonly(any)[]
		guide_rows( id: any): readonly(any)[]
		Guides( id: any): $mol_view
		toggle_left( id: any): string
		expanded( id: any, next?: boolean ): boolean
		Toggle( id: any): $mol_check_expand
		content_left( id: any): string
		Content( id: any): $mol_view
		roots( next?: readonly(any)[] ): readonly(any)[]
		children( id: any, next?: readonly(any)[] ): readonly(any)[]
		expanded_state( id: any, next?: boolean ): boolean
		expanded_default( id: any): boolean
		expanded_key( id: any): string
		indent( ): number
		Item( id: any): $mol_view
		Guide( id: any): $mol_view
		rows( ): ReturnType< $shm_tree['visible_rows'] >
		Row( id: any): $mol_view
	}
	
}

//# sourceMappingURL=tree.view.tree.d.ts.map